module.exports = __webpack_public_path__ + "dist/assets/browser-safari.71a25aa836a66d4e2514acbf0cb5f7aa.png";